import type { Guide } from '../types';

/** S-21.10-08 — wniosek o zmianę pojazdu po wyjeździe na załadunek (scenariusz e2e 18, FTL-01). */
export const guide: Guide = {
  flagKey: 'vehicleChangeRequest',
  title: 'Wniosek o zmianę pojazdu po wyjeździe na załadunek',
  whatItDoes:
    'Gdy pojazd wyruszył już na załadunek, planista FTL nie zmienia go sam: wybiera inny swój pojazd, podaje powód i wysyła wniosek do Team Leadera. Team Leader albo administrator akceptuje — zlecenie zostaje obsadzone wybranym pojazdem jak przy „Zmień pojazd”, ze wszystkimi blokadami obsadzenia — albo odrzuca z powodem. Wnioskujący może wniosek wycofać i dostaje powiadomienie o decyzji.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-21.10-08'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie obsadzone Twoim pojazdem, którego okno załadunku już trwa',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'vehicle-change-request',
      mockupTestId: 'ftl-zlecenie-obsadzenie',
      title: 'Auto wyruszyło — wniosek zamiast zmiany',
      description:
        'Karta mówi, że auto wyruszyło na załadunek i zmianę pojazdu zatwierdza Team Leader. Formularz: proponowany pojazd i powód (co najmniej 10 znaków).',
      action: 'Wybierz proponowany pojazd, wpisz powód i kliknij „Wnioskuj o zmianę pojazdu”.',
      recorder: { account: 'ftl2', demo: { kind: 'order', number: 'DEMO/2026/10/W02' } },
    },
    {
      route: '/ftl-team-leader-dashboard',
      target: 'ftl-tile-changeRequestsPending',
      title: 'Decyzja Team Leadera',
      description:
        'Nowy wniosek trafia na pulpit Team Leadera i do jego powiadomień. Na karcie zlecenia baner wniosku ma „Akceptuję” i „Odrzucam” — akceptacja obsadza proponowanym pojazdem, odrzucenie wymaga powodu.',
      action: 'Kliknij kafelek „Wnioski o zmianę pojazdu i przekazanie”, otwórz zlecenie i zdecyduj na banerze.',
      recorder: { account: 'master' },
    },
  ],
};
